import React, { Component } from 'react'
import * as PropTypes from 'prop-types'
import axios from 'axios'
import { Button, Form, Modal, Select, Spin } from 'antd'
import { debounce } from 'lodash'
import { API_ERRO_TYPE_CANCEL } from '../../config/general'
import { companiesService, departmentsService, employeesService, justificationsService } from '../../redux/services'

class Filters extends Component {
  static propTypes = {
    visible: PropTypes.bool.isRequired,
    onComplete: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props)

    this.filtersClean = {
      empresa: null,
      departamento: null,
      funcionario: null,
      justificativa: null,
    }

    this.state = {
      filters: {
        ...this.filtersClean,
        companiesIsLoading: false,
        companies: [],
        departmentsIsLoading: false,
        departments: [],
        employeesIsLoading: false,
        employees: [],
        justificationsIsLoading: false,
        justifications: [],
      },
    }
  }

  fetchCompanies = (value) => {
    if (this._axiosCancelTenantsToken) {
      this._axiosCancelTenantsToken.cancel(
        'Only one request allowed at a time.'
      )
    }

    this._axiosCancelTenantsToken = axios.CancelToken.source()

    // if (value !== undefined && !value.trim().length) {
      // this.setState({
        // companiesIsLoading: false,
        // companies: [],
      // })

      // return false
    // }

    this.setState({
      companiesIsLoading: true,
    })

    companiesService
      .getAll({
        ...(value ? { search: value } : {}),
        cancelToken: this._axiosCancelTenantsToken.token,
      })
      .then((response) => {
        this.setState({
          companiesIsLoading: false,
          companies: response.data.data,
        })
      })
      .catch((data) => {
        if (data.error_type === API_ERRO_TYPE_CANCEL) return null

        this.setState({
          companiesIsLoading: false,
        })

        Modal.error({
          title: 'Ocorreu um erro!',
          content: String(data),
        })
      })
  }

  fetchCompaniesSearch = debounce(this.fetchCompanies, 500)

  fetchDepartments = (value) => {
    if (this._axiosCancelTenantsToken) {
      this._axiosCancelTenantsToken.cancel(
        'Only one request allowed at a time.'
      )
    }

    this._axiosCancelTenantsToken = axios.CancelToken.source()

    // if (value !== undefined && !value.trim().length) {
      // this.setState({
        // departmentsIsLoading: false,
        // departments: [],
      // })

      // return false
    // }

    this.setState({
      departmentsIsLoading: true,
    })

    departmentsService
      .getAll({
        ...(value ? { search: value } : {}),
        cancelToken: this._axiosCancelTenantsToken.token,
      })
      .then((response) => {
        this.setState({
          departmentsIsLoading: false,
          departments: response.data.data,
        })
      })
      .catch((data) => {
        if (data.error_type === API_ERRO_TYPE_CANCEL) return null

        this.setState({
          departmentsIsLoading: false,
        })

        Modal.error({
          title: 'Ocorreu um erro!',
          content: String(data),
        })
      })
  }

  fetchDepartmentsSearch = debounce(this.fetchDepartments, 500)

  fetchEmployees = (value) => {
    if (this._axiosCancelTenantsToken) {
      this._axiosCancelTenantsToken.cancel(
        'Only one request allowed at a time.'
      )
    }

    this._axiosCancelTenantsToken = axios.CancelToken.source()

    // if (value !== undefined && !value.trim().length) {
      // this.setState({
        // employeesIsLoading: false,
        // employees: [],
      // })

      // return false
    // }

    this.setState({
      employeesIsLoading: true,
    })

    employeesService
      .getAll({
        ...(value ? { search: value } : {}),
        cancelToken: this._axiosCancelTenantsToken.token,
      })
      .then((response) => {
        this.setState({
          employeesIsLoading: false,
          employees: response.data.data,
        })
      })
      .catch((data) => {
        if (data.error_type === API_ERRO_TYPE_CANCEL) return null

        this.setState({
          employeesIsLoading: false,
        })

        Modal.error({
          title: 'Ocorreu um erro!',
          content: String(data),
        })
      })
  }

  fetchEmployeesSearch = debounce(this.fetchEmployees, 500)

  fetchJustifications = (value) => {
    if (this._axiosCancelTenantsToken) {
      this._axiosCancelTenantsToken.cancel(
        'Only one request allowed at a time.'
      )
    }

    this._axiosCancelTenantsToken = axios.CancelToken.source()

    // if (value !== undefined && !value.trim().length) {
      // this.setState({
        // justificationsIsLoading: false,
        // justifications: [],
      // })

      // return false
    // }

    this.setState({
      justificationsIsLoading: true,
    })

    justificationsService
      .getAll({
        ...(value ? { search: value } : {}),
        cancelToken: this._axiosCancelTenantsToken.token,
      })
      .then((response) => {
        this.setState({
          justificationsIsLoading: false,
          justifications: response.data.data,
        })
      })
      .catch((data) => {
        if (data.error_type === API_ERRO_TYPE_CANCEL) return null

        this.setState({
          justificationsIsLoading: false,
        })

        Modal.error({
          title: 'Ocorreu um erro!',
          content: String(data),
        })
      })
  }

  fetchJustificationsSearch = debounce(this.fetchJustifications, 500)

  onOpen = (filters) => {
    this.setState({
      filters: filters,
    })
  }

  cleanFilters = () => {
    this.setState(
      {
        filters: this.filtersClean,
      },
      () => {
        // Callback
        this.props.onComplete({ ...this.state.filters })
      }
    )
  }

  onClose = () => {
    // Callback
    this.props.onClose()
  }

  filtersOnConfirm = () => {
    // Callback
    this.props.onComplete({ ...this.state.filters })
  }

  setFilter = (name, value) => {
    this.setState((state) => ({
      filters: {
        ...state.filters,
        [name]: value,
      },
    }))
  }

  render() {
    const { visible } = this.props

    const { filters, companies, companiesIsLoading, departments, departmentsIsLoading, employeesIsLoading, employees, justificationsIsLoading, justifications } = this.state

    return (
      <Modal
        visible={visible}
        title="Filtrar"
        centered={true}
        destroyOnClose={true}
        maskClosable={true}
        width={900}
        okText="Aplicar"
        onCancel={this.onClose}
        onOk={this.filtersOnConfirm}
        className="modal-filters"
        footer={[
          <Button key="back" type="link" onClick={this.cleanFilters}>
            Excluir filtros
          </Button>,
          <Button key="submit" type="primary" onClick={this.filtersOnConfirm}>
            Aplicar
          </Button>,
        ]}
      >
        <div className="filter-group">
          <div className="filter-group-title">
            <h3>Empresa</h3>
          </div>
          <div className="filter-group-filters" style={{ paddingBottom: 0 }}>
            <Form.Item>
              <Select
                filterOption={false}
                allowClear
                placeholder="Pesquise a empresa"
                notFoundContent={
                  companiesIsLoading ? (
                    <Spin
                      indicator={<i className="fad fa-spinner-third fa-spin" />}
                    />
                  ) : null
                }
                onDropdownVisibleChange={(open) => open && this.fetchCompanies()}
                onSearch={this.fetchCompaniesSearch}
                onChange={(value) =>
                  this.setFilter('empresa', value ?? null)
                }
                showSearch
                value={filters.empresa}
              >
                {companies?.map((item, index) => (
                  <Select.Option key={index} value={item.uuid}>
                    {item.nome}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </div>
        </div>
        <div className="filter-group">
          <div className="filter-group-title">
            <h3>Departamento</h3>
          </div>
          <div className="filter-group-filters" style={{ paddingBottom: 0 }}>
            <Form.Item>
              <Select
                filterOption={false}
                allowClear
                placeholder="Pesquise o departamento"
                notFoundContent={
                  departmentsIsLoading ? (
                    <Spin
                      indicator={<i className="fad fa-spinner-third fa-spin" />}
                    />
                  ) : null
                }
                onDropdownVisibleChange={(open) => open && this.fetchDepartments()}
                onSearch={this.fetchDepartmentsSearch}
                onChange={(value) =>
                  this.setFilter('departamento', value ?? null)
                }
                showSearch
                value={filters.departamento}
              >
                {departments?.map((item, index) => (
                  <Select.Option key={index} value={item.uuid}>
                    {item.nome}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </div>
        </div>
        <div className="filter-group">
          <div className="filter-group-title">
            <h3>Funcionário</h3>
          </div>
          <div className="filter-group-filters" style={{ paddingBottom: 0 }}>
            <Form.Item>
              <Select
                filterOption={false}
                allowClear
                placeholder="Pesquise o funcionário"
                notFoundContent={
                  employeesIsLoading ? (
                    <Spin
                      indicator={<i className="fad fa-spinner-third fa-spin" />}
                    />
                  ) : null
                }
                onDropdownVisibleChange={(open) => open && this.fetchEmployees()}
                onSearch={this.fetchEmployeesSearch}
                onChange={(value) =>
                  this.setFilter('funcionario', value ?? null)
                }
                showSearch
                value={filters.funcionario}
              >
                {employees?.map((item, index) => (
                  <Select.Option key={index} value={item.uuid}>
                    {item.nome}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </div>
        </div>
        <div className="filter-group">
          <div className="filter-group-title">
            <h3>Justificativa</h3>
          </div>
          <div className="filter-group-filters" style={{ paddingBottom: 0 }}>
            <Form.Item>
              <Select
                filterOption={false}
                allowClear
                placeholder="Pesquise a justificativa"
                notFoundContent={
                  justificationsIsLoading ? (
                    <Spin
                      indicator={<i className="fad fa-spinner-third fa-spin" />}
                    />
                  ) : null
                }
                onDropdownVisibleChange={(open) => open && this.fetchJustifications()}
                onSearch={this.fetchJustificationsSearch}
                onChange={(value) =>
                  this.setFilter('justificativa', value ?? null)
                }
                showSearch
                value={filters.justificativa}
              >
                {justifications?.map((item, index) => (
                  <Select.Option key={index} value={item.uuid}>
                    {item.nome}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </div>
        </div>
      </Modal>
    )
  }
}

export default Filters
